import type { RequestOptions } from "@@/plugin-request/request";
import type { RequestConfig } from "@umijs/max";
import { history } from "@umijs/max";
import { message } from "antd";

const TOKEN_KEY = "ourwork_token";
const loginPath = "/user/login";

/**
 * 后端统一响应格式：{ code: 0, msg: "ok", data: T }
 * code === 0 成功，其余为错误码
 */
export const errorConfig: RequestConfig = {
  errorConfig: {
    errorThrower: (res) => {
      const { code, msg, data } = res as any;
      if (typeof code === "number" && code !== 0) {
        const error: any = new Error(msg || "请求失败");
        error.name = "BizError";
        error.info = { code, msg, data };
        throw error;
      }
    },
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (error.name === "BizError") {
        const { code, msg: errorMsg } = error.info || {};
        if (code === 401) {
          localStorage.removeItem(TOKEN_KEY);
          if (window.location.pathname !== loginPath) {
            history.replace({
              pathname: loginPath,
              search: new URLSearchParams({
                redirect: window.location.pathname + window.location.search,
              }).toString(),
            });
          }
          return;
        }
        message.error(errorMsg || "请求失败");
      } else if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          localStorage.removeItem(TOKEN_KEY);
          if (window.location.pathname !== loginPath) {
            history.replace({
              pathname: loginPath,
              search: new URLSearchParams({
                redirect: window.location.pathname + window.location.search,
              }).toString(),
            });
          }
          return;
        }
        message.error(`请求错误 ${status}`);
      } else if (error.request) {
        message.error("网络异常，请检查网络连接");
      } else {
        message.error("请求异常，请重试");
      }
    },
  },

  requestInterceptors: [
    (config: RequestOptions) => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (token) {
        config.headers = {
          ...config.headers,
          satoken: token,
        };
      }
      const locale = localStorage.getItem("umi_locale") || "ja-JP";
      config.headers = {
        ...config.headers,
        "X-Lang": locale,
        "X-App-Code": "user-web",
      };
      return config;
    },
  ],

  responseInterceptors: [
    (response: any) => {
      const data = response.data;
      if (data && typeof data.code === "number" && data.code === 0) {
        let inner = data.data;
        // MyBatis-Flex Page 对象转換为前端约定的 { list, total } 格式
        if (
          inner &&
          Array.isArray(inner.records) &&
          typeof inner.totalRow === "number"
        ) {
          inner = { list: inner.records, total: inner.totalRow };
        }
        response.data = inner;
      }
      return response;
    },
  ],
};
